import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import { Observable } from 'rxjs';


import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {RequestValidationMessagesComponent} from '../../components/Requests/RequestValidationMessages.component';
import {RequestTypeMultiSelectComponent} from '../../components/DomainData/RequestTypeMultiSelect.component';
import {RequestStatusMultiSelectComponent} from '../../components/DomainData/RequestStatusMultiSelect.component';
import {SalesOfficeMultiSelectComponent} from '../../components/DomainData/SalesOfficeMultiSelect.component';
import {EmployeeMultiSelectComponent} from '../../components/Employees/EmployeeMultiSelect.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {RequestActionGridComponent} from '../../components/Grids/RequestActionGrid.component';
import { SecurityUtil } from '../../util/index';
import { RequestType } from '../../entities/index';
import { RequestTypeEnum } from '../../enums/index';

@Component({
  selector: 'my-requests-grid',
  templateUrl: './RequestsGrid.component.html'
})
export class RequestsGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    
    @Input() showCustomerColumns: boolean = true;
    @Input() showFSPCustomerColumns: boolean = false;
    @Input() loadMultiSelectsOnInit: boolean = true;


    @Output() public openRequestTab: EventEmitter<Request> = new EventEmitter();
    @Output() public updateRequests: EventEmitter<boolean> = new EventEmitter();
    
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(RequestTypeMultiSelectComponent) requestTypeMultiSelectComponent: RequestTypeMultiSelectComponent;
    @ViewChild(RequestStatusMultiSelectComponent) requestStatusMultiSelectComponent: RequestStatusMultiSelectComponent;
    @ViewChild(SalesOfficeMultiSelectComponent) salesOfficeMultiSelectComponent: SalesOfficeMultiSelectComponent;
    @ViewChild(EmployeeMultiSelectComponent) employeeMultiSelectComponent: EmployeeMultiSelectComponent;
    @ViewChild(RequestValidationMessagesComponent) requestValidationMessagesComponent: RequestValidationMessagesComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(RequestActionGridComponent) requestActionGridComponent: RequestActionGridComponent;

    displayDialog: boolean;
    displayConfirmDeleteDialog: boolean;
    displayConfirmDeleteMultipleDialog: boolean;
    displayCompleteMultipleDialog: boolean;
    displayInProgressMultipleDialog: boolean;
    displayRejectMultipleDialog: boolean;
    displayConfirmEmailDialog: boolean;
    displayRejectRequestDialog: boolean;
    displayCompletionDetailsDialog: boolean;
    displayBatchDetailsDialog: boolean;
    displayRequestActionsDialog: boolean;
    rejectComments: string;
    requests: ent.Request[];
    requestToDelete: ent.Request;
    requestTypeIDsToSelectOnLoad: number[] = [];
    requestStatusIDsToSelectOnLoad: number[] = [];
    employeeIDsToSelectOnLoad: number[] = [];
    salesOfficeIDsToSelectOnLoad: number[] = [];
    requestToEmail: ent.Request;
    requestToReject: ent.Request;
    selectedRequests: ent.Request[] = [];
    requestMenuItems: MenuItem[];
    requestID?: number;
    batchID?: number;
    downloadBatchID?: number;
    requestIDForRequestActionDialog?: number;
    startDate?: Date;
    endDate?: Date;
    cols: any[];
    attachments: ent.Attachment[] = [];
    appConfig: ent.AppConfig;


    constructor(private authenticationService: serv.AuthenticationService, private requestService: serv.RequestService, private confirmationService: ConfirmationService,
         private router: Router, private configService: serv.ConfigService) 
    {
        this.appConfig = configService.appConfig;
    }

    //#region Init
    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        
        this.loadMenus();
        this.loadColumns();
        

    }

    ngAfterViewInit() {
        if (this.loadMultiSelectsOnInit){
            this.loadSearchCriteria();
        }

    }
    //#endregion
    
    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'RequestType.Name', header: 'Request Type' },
            { field: 'RequestStatus.Name', header: 'Request Status' },
            { field: 'SalesOffice.Name', header: 'Sales Office Name' },
            { field: 'Employee.FullName', header: 'Requestor' }
        ];

        if (this.showCustomerColumns){
            this.cols.push({ field: 'GeneralInfo.CustomerNumber', header: 'Customer #' });
            this.cols.push({ field: 'GeneralInfo.BusinessName', header: 'Customer Name' });
        }

        if (this.showFSPCustomerColumns){
            this.cols.push({ field: 'FullServicePricingInfo.ZQCustomerNumber', header: 'Recipient ID' });
            this.cols.push({ field: 'FullServicePricingInfo.ZQCustomerName', header: 'Recipient Name' });
            this.cols.push({ field: 'NeedsReview', header: 'Needs Review' });
        }

        this.cols.push({ field: 'RequestDate', header: 'Request Date' });
        this.cols.push({ field: 'AgingDays', header: 'Aging Days' });
        this.cols.push({ field: 'AssignedToEmployee.FullName', header: 'Assigned To' });
        this.cols.push({ field: 'CustomerNumber', header: 'Customer #' });
        this.cols.push({ field: 'CompletionNumbers', header: 'Completion #(s)' });

        if (this.showBatchInfo()){
            this.cols.push({ field: 'BatchID', header: 'Batch #' });
        }
        
    }

    loadSearchCriteria() {
        
        Observable.forkJoin([
            this.loadEmployees(),
            this.loadRequestStatuses(),
            this.loadRequestTypes(),
            this.loadSalesOffices()
          ]).subscribe(value => {
                
          });
        
    }

    getGlobalFilterFields(): string[]{
        var fields = ['ID','RequestType.Name','RequestStatus.Name','SalesOffice.Name','Employee.FullName','GeneralInfo.CustomerNumber'
            ,'GeneralInfo.BusinessName','FullServicePricingInfo.ZQCustomerNumber','FullServicePricingInfo.ZQCustomerName','AgingDays','AssignedToEmployee.FullName','CustomerNumber'];
        return fields;
    }

    //#region Load domain data
    loadRequestTypes(): Observable<any> {
        
        return new Observable((observer) => { 
            this.requestTypeMultiSelectComponent.IDsToSelectOnLoad = this.requestTypeIDsToSelectOnLoad;
            this.requestTypeMultiSelectComponent.load().subscribe(x=> {
                observer.next(x);
                observer.complete();
            })
        });
    }
    
    loadRequestStatuses(): Observable<any> {
        return new Observable((observer) => { 
            this.requestStatusMultiSelectComponent.IDsToSelectOnLoad = this.requestStatusIDsToSelectOnLoad;
            this.requestStatusMultiSelectComponent.load().subscribe(x => {
                observer.next(x);
                observer.complete();
            });
        });
    }

    loadEmployees(): Observable<any> {
        return new Observable((observer) => { 
            this.employeeMultiSelectComponent.IDsToSelectOnLoad = this.employeeIDsToSelectOnLoad;
            if (this.userInfo.Employee.IsSuper == false){
                this.employeeMultiSelectComponent.load().subscribe(x => {
                    observer.next(x);
                    observer.complete();
                });
            }
            else {
                observer.next(null);
                observer.complete();
            }
            
        });
    }

    loadSalesOffices(): Observable<any> {
        
        return new Observable((observer) => { 
            this.salesOfficeMultiSelectComponent.IDsToSelectOnLoad = this.salesOfficeIDsToSelectOnLoad;
            this.salesOfficeMultiSelectComponent.load().subscribe(x=> {
                observer.next(x);
                observer.complete();
            });

        });
    }
    //#endregion

    loadMenus(){
        this.requestMenuItems = [
            {label: 'Delete', icon: 'fa-trash-o', command: (event: any) => {
                this.deleteRequests(event);
            }}
        ];

        if (SecurityUtil.CanAccessFeature(this.userInfo, enums.Feature.PerformRequestWorkflow)){
            this.requestMenuItems.push({label: 'Email', icon: 'fa-envelope-o', command: (event: any) => {this.emailRequests(event);}});
            this.requestMenuItems.push({label: 'In Progress', icon: 'fa-tasks', command: (event: any) => {this.inProgressRequests(event);}});
            this.requestMenuItems.push({label: 'Reject', icon: 'fa-ban', command: (event: any) => {this.rejectRequests(event);}});
            this.requestMenuItems.push({label: 'Complete', icon: 'fa-thumbs-o-up', command: (event: any) => {this.completeRequests(event);}});
        }

        if (this.showBatchInfo()){
            this.requestMenuItems.push({label: 'Export', icon: 'fa-files-o', command: (event: any) => {this.exportRequests(event);}});
        }
    }

    onHideDialog(event: any){
        this.displayDialog = false;
    }
    onHideConfirmDeleteDialog(event: any){
        this.displayConfirmDeleteDialog = false;
    }
    onHideConfirmDeleteMultipleDialog(event: any){
        this.displayConfirmDeleteMultipleDialog = false;
    }
    onHideConfirmEmailDialog(event: any){
        this.displayConfirmEmailDialog = false;
    }

    onCancelClick(event: any){
        
        this.displayDialog = false;
    }

    onEditClick(event: any, request: Request){
        this.openRequestTab.emit(request);
    }
    
    //#region Emailing Multiple Requests
    emailRequests(event: any){
        
        var atLeastOneRequestAlreadyEmailed: boolean;
        for (var request of this.selectedRequests){
            //if (RequestUtil.IsCustomerRequest(request) && request.RequestStatusID == RequestStatusEnum.Emailed){
            if (request.RequestStatusID == enums.RequestStatusEnum.Emailed){
                atLeastOneRequestAlreadyEmailed = true;
            }
        }
        

        if (atLeastOneRequestAlreadyEmailed){
            var messages: ent.ValidationMessage[] = [];
            var message: ent.ValidationMessage = {Category: "Error", MessageText: Constants._ONE_OR_MORE_REQUESTS_ALREADY_EMAILED};
            messages.push(message);

            this.requestValidationMessagesComponent.displayDialog = true;
            this.requestValidationMessagesComponent.messages = messages;
        }
        else{
            if (this.selectedRequests.length > 1){
                this.displayDialog = true;
            }
            else{
                this.blockComponent.blocked = true;
                for(var request of this.selectedRequests){
                    var filter: filters.RequestFilter = {RequestID: request.ID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName()}; 
                    this.requestService.emailRequest(filter).subscribe(x=>
                        {
                            this.messageHandlerComponent.handleResponse(x);
                            this.updateRequests.emit(true);
                            this.onSearchClick(null);
                            this.blockComponent.blocked = false;
                        })
                        
                }
            }
        }
    }

    

    onSeparateClick(event: any){
        for(var request of this.selectedRequests){
            var filter: filters.RequestFilter = {RequestID: request.ID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName()}; 
            this.requestService.emailRequest(filter).subscribe(x=>
                {
                    this.messageHandlerComponent.handleResponse(x);
                    this.updateRequests.emit(true);
                    this.onSearchClick(event);
                }, err => {
                    this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                    this.blockComponent.blocked = false;
                });
        }
        
        this.displayDialog = false;
    }
    onMergedClick(event: any){
        
        var filter: filters.RequestFilter = {RequestIDs: [], AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName()}; 
        for(var request of this.selectedRequests){
            filter.RequestIDs.push(request.ID);
        }
        
        this.requestService.emailRequest(filter).subscribe(x=>this.messageHandlerComponent.handleResponse(x), err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
        this.updateRequests.emit(true);
        this.onSearchClick(event);
        
        this.displayDialog = false;
    }
    //#endregion
    
    //#region Search
    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        var filter: filters.RequestFilter = {Take: 1000};
        if (this.requestID && this.requestID > 0){
            filter.RequestID = this.requestID;
        }
        else if (this.batchID && this.batchID > 0){
            filter.BatchID = this.batchID;
        }
        else{
            filter = 
            {
                RequestTypeIDs: this.requestTypeMultiSelectComponent.selectedIDs,
                RequestStatusIDs: this.requestStatusMultiSelectComponent.selectedIDs,
                EmployeeIDs: this.employeeMultiSelectComponent.selectedIDs,
                SalesOfficeIDs: this.salesOfficeMultiSelectComponent.selectedIDs,
                RequestDateStart: this.startDate,
                RequestDateEnd: this.endDate
            };
        }
        
        this.requestService.getRequests(filter).subscribe(x=>this.onSearchClickDone(x), err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }
    
    onSearchClickDone(requests: ent.Request[]){
        for(var request of requests){
            if (request.FullServicePricingInfo){
                request.NeedsReview = request.FullServicePricingInfo.NeedsReview;
            }
        }
        this.requests = requests;
        this.selectedRequests = [];
        this.blockComponent.blocked = false;
    }
    //#endregion

    //#region Email Single Request
    onEmailClick(event: any, request: ent.Request){
        
        this.checkForSuppressSingle(request);
       
    }

    checkForSuppressSingle(request: ent.Request){
        if (request.SuppressInfo && (request.SuppressInfo.SuppressCustomer || request.RequestTypeID == RequestTypeEnum.SuppressCustomer)){
            this.confirmationService.confirm({
                message: Constants._EMAIL_REQUEST_WITH_SUPPRESS_CONFIRMATION,
                key: "cd",
                accept: () => {
                    this.emailSingle(request);
                },
                reject: () => {
                    this.blockComponent.blocked = false;
                }
            });
        }
        else if (request.GeneralInfo && request.GeneralInfo.IncludeOwnershipChange == true){
            this.confirmationService.confirm({
                message: Constants._EMAIL_REQUEST_WITH_OWNERSHIP_CHANGE,
                key: "cd",
                accept: () => {
                    this.emailSingle(request);
                },
                reject: () => {
                    this.blockComponent.blocked = false;
                }
            });
        }
        else{
            this.emailSingle(request);
        }
    }

    emailSingle(request: ent.Request){
        var filter: filters.RequestFilter = {RequestID: request.ID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName()};
        this.requestToEmail = request;
        var requestStatusID: number;
        var continueWithEmailing: boolean;
        this.requestService.getRequestStatus(filter).subscribe(x=>
            {
                requestStatusID = x;
                if (requestStatusID == enums.RequestStatusEnum.Emailed){
                    //if (RequestUtil.IsCustomerRequest(request)){
                    if (true){
                        var messages: ent.ValidationMessage[] = [];
                        var message: ent.ValidationMessage = {Category: "Error", MessageText: Constants._REQUEST_ALREADY_EMAILED};
                        messages.push(message);

                        this.requestValidationMessagesComponent.displayDialog = true;
                        this.requestValidationMessagesComponent.messages = messages;
                    }
                }
                else{
                    this.emailRequest(filter);
                }
            }, err => 
            {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            }
        );
    }
    //#endregion

    //#region Workflow-related methods: (Submit, Complete, Approve, InProgress, etc.)
    onSubmitClick(event: any, request: ent.Request){
        
        var filter: filters.RequestFilter = {RequestID: request.ID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName()};
        this.blockComponent.blocked = true;
        this.requestService.submitRequest(filter).subscribe(x=>
            {
                if (x.Success){
                    this.messageHandlerComponent.handleResponse(x);
                    this.updateRequests.emit(true);
                    this.onSearchClick(event);
                }
                else{
                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = [];
                    for (var vm of x.ValidationMessages){
                        this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                    }
                    
                }
                this.blockComponent.blocked = false;
            }, err => {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            });
    }

    onCompleteClick(event: any, request: ent.Request){
        
        this.doComplete([request]);
       
    }

    doComplete(requests: ent.Request[]){
        this.blockComponent.blocked = true;
        var completeRequest: ent.CompleteRequestsRequest = {Requests: requests, ValidateCompletionNumbers: true, Employee: this.userInfo.Employee};
        this.requestService.completeRequest(completeRequest).subscribe(x=>
            {
                if (x.Success){
                    this.messageHandlerComponent.handleResponse(x);
                    this.updateRequests.emit(true);
                    this.onSearchClick(event);
                }
                else{
                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = [];
                    for (var vm of x.ValidationMessages){
                        this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                    }
                    
                }
                this.blockComponent.blocked = false;
            }, err => {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            });
    }

    onApproveClick(event: any, request: ent.Request){
        
        this.onEmailClick(event, request);
    }

    onRejectClick(event: any, request:ent.Request){
        this.requestToReject = request;
        switch (request.RequestTypeID)
        {
            case enums.RequestTypeEnum.SuppressCustomer:
            case enums.RequestTypeEnum.UnsuppressCustomer:
                this.rejectComments = Constants._DEFAULT_REJECT_COMMENTS_FOR_SUPPRESSION_REQUESTS;
                break;
            default:
                this.rejectComments = "";
                break;
        }
        this.displayRejectRequestDialog = true;
        
    }

    onInProgressClick(event: any, request: ent.Request){
        
        var filter: filters.RequestFilter = {RequestID: request.ID, ActionEmployeeID: this.userInfo.Employee.ID};
        
        this.doInProgress(filter);
    }

    doInProgress(filter: filters.RequestFilter){
        this.blockComponent.blocked = true;
        this.requestService.inProgressRequest(filter).subscribe(x=>
            {
                if (x.Success){
                    this.messageHandlerComponent.handleResponse(x);
                    this.updateRequests.emit(true);
                    this.onSearchClick(event);
                }
                else{
                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = [];
                    for (var vm of x.ValidationMessages){
                        this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                    }
                    
                }
                this.blockComponent.blocked = false;
            }, err => {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            });
    }
    //#endregion

    //#region Set Multiple Requests to In Progress
    inProgressRequests(event: any){
        this.displayInProgressMultipleDialog = true;
    }

    onInProgressMultipleYesClick(event: any){
        var requestIDs: number[] = [];
        for(var request of this.selectedRequests){
            for (var item of this.selectedRequests){
                requestIDs.push(item.ID);
            }
        }
        if (requestIDs.length > 0){
            var filter: filters.RequestFilter = {RequestIDs: requestIDs, ActionEmployeeID: this.userInfo.Employee.ID};
            this.doInProgress(filter);
        }
        
        this.displayInProgressMultipleDialog = false;
    }

    onInProgressMultipleCancelClick(event: any){
        this.displayInProgressMultipleDialog = false;
    }

    onHideConfirmInProgressMultipleDialog(event: any){
        this.displayInProgressMultipleDialog = false;
    }
    //#endregion

    //#region Set Multiple Requests to Completed
    completeRequests(event: any){
        this.displayCompleteMultipleDialog = true;
    }

    onCompleteMultipleYesClick(event: any){
        var requestIDs: number[] = [];
        for(var request of this.selectedRequests){
            for (var item of this.selectedRequests){
                requestIDs.push(item.ID);
            }
        }
        if (this.selectedRequests.length > 0){
        
            this.doComplete(this.selectedRequests);
        }
        
        this.displayCompleteMultipleDialog = false;
    }

    onCompleteMultipleCancelClick(event: any){
        this.displayCompleteMultipleDialog = false;
    }

    onHideConfirmCompleteMultipleDialog(event: any){
        this.displayCompletionDetailsDialog = false;
    }
    //#endregion

    //#region Set Multiple Requests to Rejected
    rejectRequests(event: any){
        this.displayRejectMultipleDialog = true;
    }

    onRejectMultipleYesClick(event: any){
        var requestIDs: number[] = [];
        for(var request of this.selectedRequests){
            for (var item of this.selectedRequests){
                requestIDs.push(item.ID);
            }
        }
        if (requestIDs.length > 0){
            var filter: filters.RequestFilter = {RequestIDs: requestIDs, ActionEmployeeID: this.userInfo.Employee.ID, Comments: this.rejectComments};
            this.doReject(filter);
        }
        
        this.displayRejectMultipleDialog = false;
    }

    onRejectMultipleCancelClick(event: any){
        this.displayRejectMultipleDialog = false;
    }

    onHideConfirmRejectMultipleDialog(event: any){
        this.displayRejectMultipleDialog = false;
    }
    //#endregion

    //#region Reject
    onRejectYesClick(event: any){
        this.rejectRequest();
        this.displayRejectRequestDialog = false;
    }

    onRejectCancelClick(event: any){
        this.displayRejectRequestDialog = false;
    }

    onHideRejectRequestDialog(event: any){
        this.displayRejectRequestDialog = false;
    }

    rejectRequest(){
        
        var filter: filters.RequestFilter = {RequestID: this.requestToReject.ID, Comments: this.rejectComments};
        this.doReject(filter);
    }

    doReject(filter: filters.RequestFilter){
        this.blockComponent.blocked = true;
        this.requestService.rejectRequest(filter).subscribe(x=>
            {
                if (x.Success){
                    this.messageHandlerComponent.handleResponse(x);
                    this.updateRequests.emit(true);
                    this.onSearchClick(event);
                }
                else{
                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = [];
                    for (var vm of x.ValidationMessages){
                        this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                    }
                    
                }
                this.blockComponent.blocked = false;
            }, err => 
            {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            });
    }
    //#endregion

    //#region Completion Details
    showCompletionDetailsButton(request: ent.Request): boolean{
        return util.SecurityUtil.ShowCompletionDetails(request, this.userInfo);
    }

    onShowCompletionDetailsClick(event: any, request:ent.Request){
        this.completionDetailsComponent.setRequestInfo(request);
        this.displayCompletionDetailsDialog = true;
    }

    onHideCompletionDetailsDialog(event: any){
        this.displayCompletionDetailsDialog = false;
    }

    onCompletionDetailsYesClick(event: any){
        
        this.blockComponent.blocked = true;
        util.RequestUtil.LoadCompletionDetails(this.completionDetailsComponent.request, this.completionDetailsComponent);
        this.requestService.saveRequestCompletionNumbers(this.completionDetailsComponent.request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
            
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
        this.displayCompletionDetailsDialog = false;
        
    }

    onCompletionDetailsCancelClick(event: any){
        this.displayCompletionDetailsDialog = false;
    }
    //#endregion

    //#region Batch Details
    onShowBatchDetailsClick(event: any, request:ent.Request){
        
        this.displayBatchDetailsDialog = true;
        this.downloadBatchID = request.BatchID;
        
        var filter: filters.RequestFilter = {BatchID: request.BatchID};
        this.requestService.getAttachments(filter).subscribe(x=>{this.attachments = x}, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }

    onHideBatchDetailsDialog(event: any){
        this.displayBatchDetailsDialog = false;
    }

    showBatchDetailsButton(request: ent.Request): boolean{
        
        return util.SecurityUtil.ShowBatchDetails(request, this.userInfo);
    }

    onDeleteAttachmentClick(event: any, attachment: ent.Attachment){
        var attachments: ent.Attachment[] = [];
        attachment.RequestID = this.requestID;
        attachments.push(attachment);
        this.requestService.deleteAttachments(attachments).subscribe(x=>{
              this.messageHandlerComponent.handleResponse(x);
              this.getAttachments();}, err => 
              {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
              });
    }

    getAttachments(){
        var filter: filters.RequestFilter = {RequestID: this.requestID};
        this.requestService.getAttachments(filter).subscribe(x=>{this.attachments = x});
    }

    onDownloadAllClick(event: any){
        var request: ent.DownloadAttachmentRequest = {BatchID: this.downloadBatchID, AllFiles: true};
        this.requestService.downloadAttachment(request).subscribe(x=>{
            var url= window.URL.createObjectURL(x.image);
            //window.open(url);
            var anchor = document.createElement("a");
            anchor.download = x.filename;
            anchor.href = url;
            anchor.click();
        })
    }

    onDownloadClick(event: any, attachment: ent.Attachment){
        var request: ent.DownloadAttachmentRequest = {BatchID: attachment.BatchID, FileName: attachment.Name};
        this.requestService.downloadAttachment(request).subscribe(x=>{
            var url= window.URL.createObjectURL(x.image);
            //window.open(url);
            var anchor = document.createElement("a");
            anchor.download = x.filename;
            anchor.href = url;
            anchor.click();
        })
    }
    //#endregion

    //#region Request Actions
    onShowRequestActionsClick(event: any, request:ent.Request){
        this.requestIDForRequestActionDialog = request.ID;
        var filter: filters.RequestActionFilter = {RequestID: request.ID};
        this.requestService.getRequestActions(filter).subscribe(x=>{
            this.requestActionGridComponent.lineItems = x;
            this.displayRequestActionsDialog = true;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
        
    }

    onHideRequestActionsDialog(event: any){
        this.displayRequestActionsDialog = false;
    }
    //#endregion

    //#region Show Batch Number column and Export button

    showBatchInfo(): boolean{
        return util.SecurityUtil.showBatchInfo(this.userInfo);
    }

    showExportButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowBatchExportButton(request, this.userInfo);
    }
    //#endregion

    //#region Export Requests
    exportRequests(event: any) {
        this.blockComponent.blocked = true;
        var requestIDs: number[] = [];
        for (var item of this.selectedRequests){
            requestIDs.push(item.ID);
        }
        var exportRequest: ent.ExportRequest = {RequestIDs: requestIDs, EmployeeID: this.userInfo.Employee.ID};
        this.doExport(exportRequest);
        
    }
    exportRequest(event: any, request: ent.Request) {
        
        var exportRequest: ent.ExportRequest = {RequestIDs: [request.ID], EmployeeID: this.userInfo.Employee.ID};
        this.doExport(exportRequest);
    }

    doExport(exportRequest: ent.ExportRequest){
        this.blockComponent.blocked = true;
        
        this.requestService.exportRequests(exportRequest).subscribe(x=>
            {
                if (x.Success){
                    this.messageHandlerComponent.handleResponse(x);
                    this.updateRequests.emit(true);
                    this.onSearchClick(event);
                }
                else{
                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = [];
                    for (var vm of x.ValidationMessages){
                        this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                    }
                    this.blockComponent.blocked = false;
                }
            }, err => {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            });
    }
    //#endregion

    //#region Email-related functions
    onEmailYesClick(event: any){
        var filter: filters.RequestFilter = {RequestID: this.requestToEmail.ID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName()};
        this.emailRequest(filter);
        this.displayConfirmEmailDialog = false;
    }

    onEmailCancelClick(event: any){
        this.displayConfirmEmailDialog = false;
    }

    emailRequest(filter: filters.RequestFilter){
        this.blockComponent.blocked = true;
        this.requestService.emailRequest(filter).subscribe(x=>
            {
                if (x.Success){
                    this.messageHandlerComponent.handleResponse(x);
                    this.updateRequests.emit(true);
                    this.onSearchClick(event);
                }
                else{
                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = [];
                    for (var vm of x.ValidationMessages){
                        this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                    }
                    
                }
                this.blockComponent.blocked = false;
            }, err => {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            });
    }
    //#endregion

    //#region Delete Single Request
    
    onDeleteClick(event: any, request: ent.Request){
        
        this.displayConfirmDeleteDialog = true;
        this.requestToDelete = request; 
    }

    onDeleteYesClick(event: any){
        this.deleteRequest(this.requestToDelete);
        
        this.displayConfirmDeleteDialog = false;
    }

    onDeleteCancelClick(event: any){
        this.displayConfirmDeleteDialog = false;
    }

    deleteRequest(request: ent.Request){
        var filter: filters.RequestFilter = {RequestID: request.ID, ActionEmployeeID: this.userInfo.Employee.ID};
        this.requestService.deleteRequest(filter).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.updateRequests.emit(true);
            this.onSearchClick(null);
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }
    //#endregion

    //#region Delete Multiple Requests
    deleteRequests(event: any){
        this.displayConfirmDeleteMultipleDialog = true;
    }

    onDeleteMultipleYesClick(event: any){
        for(var request of this.selectedRequests){
            this.deleteRequest(request);
        }
        
        this.displayConfirmDeleteMultipleDialog = false;
    }

    onDeleteMultipleCancelClick(event: any){
        this.displayConfirmDeleteMultipleDialog = false;
    }
    //#endregion

    //#region Logic for whether to show/disable Submit, Complete and Email buttons
    showSubmitButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowSubmitButton(request, this.userInfo);
    }

    disableSubmitButton(request: ent.Request): boolean {
        return util.SecurityUtil.DisableSubmitButton(request);
    }

    showCompleteButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowCompleteButton(request, this.userInfo);
    }

    showApproveButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowApproveButton(request, this.userInfo);
    }

    disableCompleteButton(request: ent.Request): boolean {
        return util.SecurityUtil.DisableCompleteButton(request);
    }

    showRejectButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowRejectButton(request, this.userInfo);
    }

    showInProgressButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowInProgressButton(request, this.userInfo);
    }

    showDeleteButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowDeleteButton(request, this.userInfo);
    }

    disableRejectButton(request: ent.Request): boolean {
        return util.SecurityUtil.DisableRejectButton(request);
    }

    showEmailButton(request: ent.Request): boolean {
        return util.SecurityUtil.ShowEmailButton(request);
    }
    //#endregion

}